
import {Vue, Component, Emit, Prop, Watch} from 'vue-property-decorator';
import moment from 'moment';

import {classesApi, accountApi} from '@/api';
import listRequest from '../../../js/listRequest.js';
import formHelper from '../../../js/account/account.helper';
import New_Teacher from './new_teacher.vue';
import New_Student from './new_student.vue';
import Empty from '@/components/Empty/index.vue';
import Batch_Validity from './batct_validity.vue';
import Teacher_Authorize from './teacher_authorize.vue';
import Class_Course_Info from './class_course_info.vue';
import Student_Course_Class from './student_course_class.vue';
import {getDomainHandle, isLocal} from '@/js/domainUtils';

@Component({
    components: {
        New_Teacher,
        New_Student,
        Empty,
        Batch_Validity,
        Teacher_Authorize,
        Class_Course_Info,
        Student_Course_Class
    }
})
export default class Account extends Vue {
    //===================================data区域begin
    // 切换教师及学生
    insidestatus: boolean = false;
    // 教师数量
    teacherTotal: number = 0;
    // 学生数量
    studentTotal: number = 0;
    //超级管理员，暂时，方便测试
    isSuperAdministor = false;
    // isSuperAdministor=true;
    // 教师列表数据加载
    teacherLoading: boolean = false;
    // 学生列表数据加载
    studentLoading: boolean = false;

    columns: any = formHelper.columns;
    pager: any = {
        default: {
            pagesize: listRequest.pagesize,
            // pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    columnsStudent: any = formHelper.columnsStudent;
    studentPager: any = {
        default: {
            pagesize: listRequest.pagesize,
            // pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };

    query: any = {
        // class: '',
        // subject: '',
        // bookName: '',
        name: '',
        // type: '',
        expireState: '',
        attribute: 'external' //只查询外部
    };
    queryStudent: any = {
        className: '',
        attribute: 'external' //只查询外部
    };

    myToken: any = window.localStorage.getItem('aicp_school_materials_$tokenKeyName_aicp_school_materials');
    schoolId: any = '';
    orgName: any = ''; //学校名称，用于导出教师表格的名称
    // 教师超出宽度显示气泡提示
    teacherNamePop: boolean = false;
    // 复制账号信息
    teacherAddress: string = '';
    studentAddress: string = '';
    copyTeacher: string = '';
    copystudent: string = '';
    // 教师授课信息详情对话框显隐
    showTeacherInfo: boolean = false;
    teacherInfo: any = {};
    // 新建或编辑教师对话框显隐
    showNewTeacher: boolean = false;
    // 新建或编辑学生对话框显隐
    showNewStudent: boolean = false;
    // 批量设置学生有效期对话框显隐
    showBatchValidityVisible: boolean = false;
    // 授课设置对话框显隐
    showTeacherAuthorize: boolean = false;
    // 授课设置数据
    authorizeTeacher: any = {};
    // 教师对话框类型
    teacherType: string = '新增';
    // 学生对话框类型
    studentType: string = '新增';
    // 编辑教师id
    teacherId: string = '';
    editTeacher: any = {};
    // 编辑学生id
    studentId: string = '';
    editStudent: any = {};
    // 表格多选框选中的key
    selectedRowKeys: any = [];
    // 表格多选框选中的学生
    selectedStudent: any = [];
    uploadHeaders: any = {};
    // 学生关联班级与课程详情对话框显隐
    showStudentInfo: boolean = false;
    studentInfo: any = {};
    //===================================data区域end

    //===================================computed区域begin
    get rowSelection() {
        return {
            columnWidth: '40px',
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = selectedRowKeys;
                // console.log(this.selectedStudent);
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                // console.log(record);
                if (selected) {
                    this.selectedStudent.push(record);
                }

                if (!selected) {
                    for (let i = 0; i < this.selectedStudent.length; i++) {
                        if (record._id == this.selectedStudent[i]._id) {
                            this.selectedStudent.splice(i, 1);
                        }
                    }
                }
                // console.log(this.selectedStudent);
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    selectedRows.forEach((el: any) => {
                        if (!this.selectedStudent.some((e: any) => e._id == el._id)) {
                            this.selectedStudent.push(el);
                        }
                    });
                } else {
                    for (let i = 0; i < changeRows.length; i++) {
                        for (let j = 0; j < this.selectedStudent.length; j++) {
                            if (this.selectedStudent[j]._id == changeRows[i]._id) {
                                this.selectedStudent.splice(j, 1);
                            }
                        }
                    }
                }
                // console.log(this.selectedStudent);
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({})
        };
    }
    //===================================computed区域end

    //===================================methods区域begin
    // 鼠标移入表格某行，行中的字体颜色变化等
    customRowTeacher() {
        return {
            on: {
                mouseenter: (record: any) => {
                    const row = record.srcElement.children;
                    if (row[4].innerText != '暂无') {
                        row[4].style.color = '#1456ed';
                        row[4].style.cursor = 'pointer';
                    }

                    // 学校名称气泡提示框显隐
                    if (row[1].offsetWidth != row[1].scrollWidth) {
                        this.teacherNamePop = true;
                    } else {
                        this.teacherNamePop = false;
                    }
                },
                mouseleave: (record: any) => {
                    const row = record.srcElement.children;
                    row[4].style.color = 'rgba(0,0,0,0.9)';
                    row[4].style.cursor = 'auto';
                },
                click: (record: any) => {
                    const row = record.srcElement.parentElement.parentElement.parentElement.parentElement.children;
                    if (row[4]) {
                        row[4].style.color = 'rgba(0,0,0,0.9)';
                        row[4].style.cursor = 'auto';
                    }
                }
            }
        };
    }
    customRowStudent() {
        return {
            on: {
                mouseenter: (record: any) => {
                    const row = record.srcElement.children;

                    if (row[6].innerText != '暂无') {
                        row[6].style.color = '#1456ed';
                        row[6].style.cursor = 'pointer';
                    }
                },
                mouseleave: (record: any) => {
                    const row = record.srcElement.children;
                    row[6].style.color = 'rgba(0,0,0,0.9)';
                    row[6].style.cursor = 'auto';
                },
                click: (record: any) => {
                    const row = record.srcElement.parentElement.parentElement.parentElement.parentElement.children;
                    if (row[6]) {
                        row[6].style.color = 'rgba(0,0,0,0.9)';
                        row[6].style.cursor = 'auto';
                    }
                }
            }
        };
    }
    switchInsideOut(flag: string) {
        if (flag === 'student') {
            // console.log('切换到学生');
            this.insidestatus = true;
        } else if (flag === 'teacher') {
            // console.log('切换到教师');
            this.insidestatus = false;
        }
    }
    // 教师账号状态筛选
    chooseTeacherState(value: any) {
        this.pager.default.pagenum = 1;
        this.query.expireState = value;
        this.getList();
    }
    // 复制教师账号信息
    copyInfoTable(record: any) {
        // console.log(record);
        const domainKey = getDomainHandle('key');
        let host = window.location.href;
        if (isLocal()) {
            this.teacherAddress = 'http://localhost:8088';
        } else if (host.includes('dev')) {
            this.teacherAddress = `https://${domainKey}-teacher-web.dev.dm-ai.com/Login`;
        } else if (host.includes('stage')) {
            this.teacherAddress = `https://${domainKey}-teacher-web.stage.dm-ai.com/Login`;
        } else if (host.includes('partner')) {
            this.teacherAddress = `https://${domainKey}-teacher-web.partner.dm-ai.com/Login`;
        } else {
            this.teacherAddress = `https://${domainKey}-teacher-web.dm-ai.com/Login`;
        }
        this.copyTeacher = `亲爱的用户:
    欢迎使用【${getDomainHandle('title')}】~\n
    点击链接打开网站
    ${this.teacherAddress}\n
    然后，使用下方的“账号”和“密码”登录
    姓名：${record.nickname}
    手机：${record.mobile}
    账号：${record.username}
    密码：
    有效期：${record.validStartTime}至${record.expireTime}`;
        this.$copyText(this.copyTeacher).then(e => {
            this.$message.success('复制成功！已复制该用户信息，粘贴给对应的师生即可。');
            // console.log(e);
        });
    }
    // 复制学生账号信息
    copyStudentInfoTable(record: any) {
        // console.log(record);
        const domainKey = getDomainHandle('key');
        let host = window.location.href;
        if (isLocal()) {
            this.studentAddress = 'http://localhost:8088';
        } else if (host.includes('dev')) {
            this.studentAddress = `https://${domainKey}-student-web.dev.dm-ai.com/Login`;
        } else if (host.includes('stage')) {
            this.studentAddress = `https://${domainKey}-student-web.stage.dm-ai.com/Login`;
        } else if (host.includes('partner')) {
            this.studentAddress = `https://${domainKey}-student-web.partner.dm-ai.com/Login`;
        } else if (host.includes('pet')) {
            this.studentAddress = `https://${domainKey}-student-web.pet.dm-ai.com/Login`;
        } else {
            this.studentAddress = `https://${domainKey}-student-web.dm-ai.com/Login`;
        }
        this.copystudent = `亲爱的用户:
    欢迎使用【${getDomainHandle('title')}】~\n
    点击链接打开网站
    ${this.studentAddress}\n
    然后，使用下方的“账号”和“密码”登录
    姓名：${record.nickname}
    账号：${record.username}
    密码：${record.password}
    有效期：${record.validStartTime}至${record.expireTime}`;
        this.$copyText(this.copystudent).then(e => {
            this.$message.success('复制成功！已复制该用户信息，粘贴给对应的师生即可。');
            // console.log(e);
        });
    }
    showPwd(record: any) {
        if (record.status == 'active') {
            record.status = 'showpwd';
        } else {
            record.status = 'active';
        }
    }
    // 授课班级与课程详情
    courseClassInfo(record: any) {
        // console.log(record);
        this.teacherInfo = record;
        this.showTeacherInfo = true;
    }
    // 授课设置
    handleSet(record: any) {
        // console.log(record);
        this.authorizeTeacher = record;
        this.showTeacherAuthorize = true;
    }
    showTeacherAuthorizeTimeout(data: any) {
        // console.log(data);
        this.authorizeTeacher = data;
        setTimeout(() => {
            this.showTeacherAuthorize = true;
        }, 1000);
    }

    // 确认重置密码
    handleResetPwd(row: any, way: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '确定重置密码?',
            centered: true,
            onOk() {
                me.userOperation(row, way);
            },
            onCancel() {}
        });
    }

    //重置密码
    userOperation(row: any, way: number) {
        let me = this;
        let postData: any;
        postData = {
            userId: row._id,
            operationType: 'password',
            username: row.username
        };

        accountApi.userOperation({
            context: this,
            data: postData,
            success(data: any, parameters: any) {
                me.getList();
                me.$message.success('密码已重置，默认密码为123456');
            }
        });
    }
    // 编辑教师
    handleEdit(record: any) {
        // 在这个函数内重新获取学校有效期并打开新建教师对话框
        this.initOrganization('refreshTeacher');
        // console.log(record);
        this.teacherType = '编辑';
        this.editTeacher = record;
        // this.showNewTeacher = true;
    }
    // 新增教师
    showNewTeacherModal() {
        // 在这个函数内重新获取学校有效期并打开新建教师对话框
        this.initOrganization('refreshTeacher');
        this.teacherType = '新增';
        // this.showNewTeacher = true;
    }
    // 查看学生关联班级与课程
    checkStudent(record: any) {
        this.studentInfo = record;
        this.showStudentInfo = true;
    }
    // 学生重置密码
    handleResetStudentPwd(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '确定重置密码?',
            centered: true,
            onOk() {
                let postData: any = {
                    userId: record._id,
                    operationType: 'password',
                    username: record.username
                };
                accountApi.userOperation({
                    context: me,
                    data: postData,
                    success(data: any, parameters: any) {
                        me.getStudentList();
                        me.$message.success('密码已重置，默认密码为123456');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 编辑
    handleStudentEdit(record: any) {
        this.initOrganization('refreshStudent');
        this.studentType = '编辑';
        this.editStudent = record;
        // this.showNewStudent = true;
    }
    // 删除
    handleInDeleteStudent(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: record.courseCount > 0 ? '删除该账号将同时取消与班级、及课程的关联，请谨慎操作。' : '账号删除后不可恢复，请谨慎操作。',
            centered: true,
            onOk() {
                accountApi.deleteRecord({
                    context: me,
                    id: record._id,
                    success(data: any, parameters: any) {
                        me.$message.success('操作成功！该学生已被删除');
                        me.getStudentList();
                        me.getUserCount('student');
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error('操作失败！该学生正在上课中，暂时无法删除。');
                    }
                });
            },
            onCancel() {}
        });
    }

    //获取学校信息
    initOrganization(flag: any) {
        let me = this;
        classesApi.getSchoolById({
            context: this,
            urlParamObj: {
                id: me.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                me.orgName = domain.name;
                domain.validStartTime = moment(domain.validStartTime).format('YYYY/MM/DD');
                domain.expireTime = moment(domain.expireTime).format('YYYY/MM/DD');
                window.localStorage.setItem('schoolInfo', JSON.stringify(domain));
                if (flag == 'refreshTeacher') {
                    me.showNewTeacher = true;
                }
                if (flag == 'refreshStudent') {
                    me.showNewStudent = true;
                }
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }

    //导出教师列表
    exportAllTeacher() {
        fetch('/api/v1/user/export/teacher', {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + this.myToken
            })
        })
            .then(res => res.blob())
            .then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = this.orgName + '教师信息' + '.xlsx';
                a.href = blobUrl;
                a.click();
            });
    }

    //导出所有学生名单
    exportAllStudent() {
        fetch('/api/v1/user/export/manage/student', {
            method: 'GET',
            headers: new Headers({
                Authorization: this.uploadHeaders['Authorization']
            })
        })
            .then(res => res.blob())
            .then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = this.orgName + '学生信息' + '.xlsx';
                a.href = blobUrl;
                console.log(data);
                if (data.type != 'application/vnd.openxmlformats') {
                    this.$message.error('导出失败');
                    return;
                }
                a.click();
            })
            .catch(err => {
                console.log(err);
            });
    }

    //查询
    onDoTeacherQueryList() {
        this.pager.default.pagenum = 1;
        this.pager.default.rows = [];
        this.getList();
    }
    onDoStudentQueryList() {
        this.studentPager.default.pagenum = 1;
        this.studentPager.default.rows = [];
        this.getStudentList();
    }
    // 批量设置学生有效期
    handleBatchValidity() {
        if (this.selectedStudent.length == 0) {
            this.$message.error('请先选择学生');
            return;
        }
        this.showBatchValidityVisible = true;
    }
    //提示确认-删除老师
    handleInDelete(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: record.classCount == 0 ? '账号删除后不可恢复，请谨慎操作。' : '删除教师将同时取消与该班级及课程的关联，请谨慎操作。',
            centered: true,
            onOk() {
                accountApi.deleteRecord({
                    context: me,
                    id: record._id,
                    success(data: any, parameters: any) {
                        me.$message.success('操作成功！该教师已被删除。');
                        me.getList();
                        me.getUserCount('teacher');
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error('操作失败！该老师正在上课中，暂时无法删除。');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 刷新教师列表
    refreshTeacherList() {
        this.pager.default.pagenum = 1;
        this.getList();
        this.getUserCount('teacher');
    }
    // 刷新学生列表
    refreshStudentList() {
        this.studentPager.default.pagenum = 1;
        this.selectedRowKeys = [];
        this.selectedStudent = [];
        this.getStudentList();
        this.getUserCount('student');
    }
    // 获取教师及学生数量
    getUserCount(role: string) {
        let me = this;
        let urlQueryParmas = {
            role: role, //角色为老师
            schoolId: me.schoolId //当前登录人员所属的学校老师
        };
        accountApi.getUserCount({
            context: me,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                if (role == 'teacher') {
                    me.teacherTotal = data.data;
                }
                if (role == 'student') {
                    me.studentTotal = data.data;
                }
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //获得教师分页表格数据
    getList() {
        let me = this;
        me.teacherLoading = true;
        let schoolId = me.schoolId;
        let urlQueryParmas = {
            attribute: me.query.attribute, //查询外部
            role: 'teacher', //角色为老师
            schoolId: schoolId, //当前登录人员所属的学校老师
            condition: me.query.name, //查询名字
            expireState: me.query.expireState // 账号状态
        };
        accountApi.getList({
            context: me,
            pager: me.pager.default,
            urlQueryParmas: urlQueryParmas,
            afterRender(data: any) {
                let dataList = data.data.list;
                // 将时间戳转换为北京时间
                for (let i = 0; i < dataList.length; i++) {
                    dataList[i].createdAt = moment(dataList[i].createdAt).format('YYYY/MM/DD HH:mm:ss');
                    dataList[i].validStartTime = moment(dataList[i].validStartTime).format('YYYY/MM/DD');
                    dataList[i].expireTime = moment(dataList[i].expireTime).format('YYYY/MM/DD');
                    if (moment(dataList[i].expireTime).format('YYYY/MM/DD') == moment().format('YYYY/MM/DD')) {
                        dataList[i].pastTime = 0;
                    } else {
                        dataList[i].pastTime = moment(dataList[i].expireTime.replace(/\//g, '-')).diff(moment(), 'day');
                        if (dataList[i].pastTime >= 0) {
                            dataList[i].pastTime += 1;
                        }
                    }
                    if (
                        dataList[i].validStartTime != moment().format('YYYY/MM/DD') &&
                        moment(dataList[i].validStartTime.replace(/\//g, '-')).diff(moment(), 'day') >= 0
                    ) {
                        dataList[i].isInvalid = true;
                    }
                }
                // console.log(data.data.list);
                me.teacherLoading = false;
                return data;
            }
        });
    }
    // 获取学生列表数据
    getStudentList() {
        let me = this;
        me.studentLoading = true;
        let urlQueryParmas = {
            condition: me.queryStudent.className,
            schoolId: me.schoolId,
            role: 'student'
        };
        classesApi.getStudentList({
            context: me,
            pager: me.studentPager.default,
            urlQueryParmas: urlQueryParmas,
            afterRender(data: any) {
                let dataList = data.data.list;
                // 将时间戳转换为北京时间
                for (let i = 0; i < dataList.length; i++) {
                    // 班级数量
                    if (dataList[i].classId) {
                        dataList[i].classCount = 1;
                    } else {
                        dataList[i].classCount = 0;
                    }
                    dataList[i].createdAt = moment(dataList[i].createdAt).format('YYYY/MM/DD HH:mm:ss');
                    dataList[i].validStartTime = moment(dataList[i].validStartTime).format('YYYY/MM/DD');
                    dataList[i].expireTime = moment(dataList[i].expireTime).format('YYYY/MM/DD');
                    if (moment(dataList[i].expireTime).format('YYYY/MM/DD') == moment().format('YYYY/MM/DD')) {
                        dataList[i].pastTime = 0;
                    } else {
                        dataList[i].pastTime = moment(dataList[i].expireTime.replace(/\//g, '-')).diff(moment(), 'day');
                        if (dataList[i].pastTime >= 0) {
                            dataList[i].pastTime += 1;
                        }
                    }
                    if (
                        dataList[i].validStartTime != moment().format('YYYY/MM/DD') &&
                        moment(dataList[i].validStartTime.replace(/\//g, '-')).diff(moment(), 'day') >= 0
                    ) {
                        dataList[i].isInvalid = true;
                    }
                }
                // console.log(dataList);
                me.studentLoading = false;
                return data;
            }
        });
    }
    //分页
    paginationChange(page: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }
    // 学生列表分页
    paginationChangeStudent(page: number) {
        this.studentPager.default.pagenum = page;
        this.getStudentList();
    }
    //初始化
    created() {
        let state = this.$app.getState();
        this.uploadHeaders['Authorization'] = 'Bearer ' + state.token;
        this.schoolId = state.schoolId;
        this.initOrganization('foo');
        this.getList();
        this.getStudentList();
        this.getUserCount('teacher');
        this.getUserCount('student');
    }
}
